import ReverseProgressBar from "./ReverseProgressBar";

export default ReverseProgressBar;